export default "__VITE_ASSET__DvAwiyMv__"